'use client'

import Image from 'next/image'
import Link from 'next/link'
import RectIcon from 'public/icons/interface/rect.svg'
import Tag from 'src/components/design-system/Tag'
import Typography from 'src/components/design-system/Typography'

const NewsItem = ({
  date,
  title,
  desc = null,
  url,
  src,
  alt,
  tags = [],
  showImagePlaceholder = false,
  classCustom = '',
}) => {
  const ariaLabel = title || desc || date || 'News item'
  const showTitle = Boolean(title && title !== desc)
  const Wrapper = url ? Link : 'div'

  return (
    <Wrapper
      {...(url ? { href: url } : {})}
      className={`group flex min-h-full flex-col gap-12 py-12 focus-visible:outline focus-visible:outline-offset-4 focus-visible:outline-functional-focus-color cursor-pointer ${classCustom}`}
      {...(url ? { 'aria-label': ariaLabel } : {})}
    >
      {(src || showImagePlaceholder) && (
        // Kadr "list" z API ma 618x380 — pole trzyma te same proporcje, żeby object-cover niczego nie obcinał.
        // Daty w rzędzie wyrównuje siatka listy, która wyrównuje szerokość treści kolumn
        <div className="relative aspect-[309/190] w-full overflow-hidden rounded-1 bg-blueish-blueish3">
          {src ? (
            <Image
              src={src}
              fill
              alt={alt || ' '}
              sizes="(min-width: 1024px) 25vw, (min-width: 768px) 50vw, 100vw"
              className="object-cover object-center transition-transform duration-500 ease-out supports-hover:group-hover:scale-105"
            />
          ) : (
            <div className="flex h-full w-full items-center justify-center" aria-hidden="true">
              <RectIcon className="h-48 w-48 opacity-60" />
            </div>
          )}
        </div>
      )}

      {date && (
        <Typography variant="body1" className="font-semibold pb-12">
          {date}
        </Typography>
      )}

      <div className="h-px w-full bg-dark-blue-dark-blue5 mb-12" aria-hidden="true" />

      {tags?.length > 0 && (
        <div className="flex flex-wrap items-center gap-6 pb-12">
          {tags.map((tag, index) => (
            <Tag
              key={`${tag?.label || 'tag'}-${index}`}
              type={tag?.type}
              label={tag?.label}
              className={
                tag?.type === 'new'
                  ? 'bg-green-green4 text-basic-black [&_.tag__dot]:bg-green-green1'
                  : 'bg-blueish-blueish3 text-basic-black'
              }
            />
          ))}
        </div>
      )}

      {showTitle && (
        <Typography variant="body1" className="font-semibold group-hover:underline" component="h3">
          {title}
        </Typography>
      )}

      {desc && (
        <Typography variant="body1" className="font-semibold line-clamp-8">
          {desc}
        </Typography>
      )}
    </Wrapper>
  )
}

export { NewsItem }
